import React, { FunctionComponent } from 'react';
import moment from 'moment';
import { v1 as uuid } from 'uuid';
import { Link } from 'react-router-dom';
import gray from '@material-ui/core/colors/grey';
import { Box, makeStyles, Slide, Theme } from '@material-ui/core';
import InspectionDetailNode from '../InspectionDetailNode';
import { Inspection } from '../../../store/modules/application/types';

type InspectionDetailNodeProps = {
    doShowDetail: boolean;
    inspection: Inspection;
    className: string;
};
const InspectionDetail: FunctionComponent<InspectionDetailNodeProps> = (props) => {
    const classes = makeStyles((theme: Theme) => ({
        header: {
            color: theme.palette.primary.light,
            fontWeight: 500,
        },
        anchorValue: {
            fontSize: 14,
            fontWeight: 450,
            color: gray[600],
        },
    }))();
    const { doShowDetail, inspection, className } = props;
    return (
        <aside>
            {!doShowDetail && <Box className={className}></Box>}
            <Slide in={doShowDetail} direction="right" mountOnEnter={true} unmountOnExit={true}>
                <Box className="detail-container detail-container-mobile">
                    <h3 className={classes.header}>DETAILS</h3>
                    <InspectionDetailNode
                        key={uuid()}
                        label="License"
                        value={`${inspection?.license?.type?.name} ${inspection?.license?.licenseNumber || ''}`}
                    />

                    {inspection?.event?.id && (
                        <InspectionDetailNode
                            key={uuid()}
                            label="Appointment"
                            value={
                                <Link
                                    to={`/licensing/appointment/${inspection?.event?.id}/detail`}
                                    className={classes.anchorValue}
                                >
                                    {inspection?.event?.type?.name +
                                        ' ' +
                                        moment(inspection?.inspectionDate).format('L')}
                                </Link>
                            }
                        />
                    )}

                    <InspectionDetailNode key={uuid()} label="Inspection Type" value={inspection?.type?.name} />
                    <InspectionDetailNode key={uuid()} label="Inspector" value={inspection?.inspector?.name} />
                    <InspectionDetailNode
                        key={uuid()}
                        label="Inspection Date"
                        value={inspection?.inspectionDate ? moment(inspection?.inspectionDate).format('L') : ''}
                    />
                </Box>
            </Slide>
        </aside>
    );
};

export default InspectionDetail;
